import "./logo.component.scss";

export default {
    template: require('./logo.component.html'),
    controller: function () {
        'ngInject';
    }
};
